<template>


  <div class="container overflow-hidden ">
    <div class="row gx-5">
      <div class="col-3">
        <div class=" border bg-light">
          <div class="col">
            <div class="divider">

            </div>
            <button @click="Voltar" type="button" class="btn btn-light">
              <feather-icon icon="ChevronLeftIcon" size="18" stroke="red" class="mr-50"/>
              Voltar para video
            </button>
            <div class="divider"></div>
            <b-tabs vertical content-class="col-12 col-md-9 mt-1 mt-md-0" pills
                    nav-wrapper-class="col-md-12 col-12" nav-class="nav-left">

<!--              <b-tab>-->
<!--                <template #title>-->
<!--                  <feather-icon icon="FileTextIcon" size="18" stroke="red" class="mr-50"/>-->
<!--                  <span class="font-weight-bold">Detalhes</span>-->
<!--                </template>-->
<!--              </b-tab>-->

<!--              <b-tab @click="customizacao">-->
<!--                <template #title>-->
<!--                  <feather-icon icon="EditIcon" size="18" stroke="red" class="mr-50"/>-->
<!--                  <span  class="font-weight-bold">Editar</span>-->
<!--                </template>-->
<!--              </b-tab>-->

              <b-tab active>
                <template #title>
                  <feather-icon icon="PieChartIcon" size="18" stroke="red" class="mr-50"/>
                  <span class="font-weight-bold">Analytics</span>
                </template>
              </b-tab>


              <!-- <b-tab>
                <template #title>
                  <feather-icon icon="ThermometerIcon" size="18" stroke="red" class="mr-50"/>
                  <span class="font-weight-bold">Teste A/B</span>
                </template>
              </b-tab> -->


              <!-- <b-tab >
                <template #title>
                  <feather-icon icon="DownloadIcon" size="18" stroke="red" class="mr-50"/>
                  <span class="font-weight-bold">Download</span>
                </template>
              </b-tab> -->

              <!-- <b-tab  @click="deleteVSL()">
                <template #title>
                  <feather-icon icon="XSquareIcon" size="18" stroke="red" sclass="mr-50"/>
                  <span class="font-weight-bold">Revover</span>
                </template>
              </b-tab> -->
            </b-tabs>
          </div>
          <div class="divider"></div>
        </div>
      </div>
      <div class="col-9 px-0">
        <detalhes>
        </detalhes>
      </div>
    </div>
  </div>

</template>

<script>
import {BTabs, BTab} from 'bootstrap-vue'
import Detalhes from './Detalhes.vue'
import Editar from './Editar.vue'
import {api} from '@/composables/useApi'

export default {
  components: {
    BTabs,
    BTab,
    Detalhes,
    Editar,
  },
  data() {
    return {
      vslId: this.$route.params.vslId,
      options: {},
    }
  },

  methods: {
    customizacao() {
      this.$router.push(`/player/${this.vslId}/customizacao`);
    },
    Voltar() {
      this.$router.push(`/player/${this.vslId}/customizacao`);
    },
  },
}
</script>

<style scoped>
.btn-link {
  color: gray;
}
</style>
